import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { useLocation, useParams } from "react-router-dom";
import { authHeader } from "_helpers";

// รับ prop embedded เพิ่มเข้ามา (default เป็น false)
const PdfFile = ({ leaveRequestId, embedded = false }) => {
    const params = useParams();
    const location = useLocation();
    const [blobUrl, setBlobUrl] = useState("");
    const [error, setError] = useState("");

    const id = useMemo(() => {
        // ถ้ามีการส่ง props leaveRequestId มาโดยตรง ให้ใช้ก่อนเลย
        if (leaveRequestId) return leaveRequestId;

        const routeId = params?.LeaveRequestID || params?.leaveRequestId || null;
        if (routeId) return routeId;
        const qs = new URLSearchParams(location.search || "");
        return qs.get("LeaveRequestID") || qs.get("leaveRequestId") || null;
    }, [leaveRequestId, params, location.search]);

    useEffect(() => {
        if (!id) return;

        let revoked = false;
        let prevUrl = "";

        (async () => {
            try {
                setError("");
                // ตรวจสอบ path API ให้ถูกต้องตาม Server ของคุณ
                const res = await axios.get(
                    `/api/v1/reportview/leaveform1?LeaveRequestID=${encodeURIComponent(id)}`,
                    {
                        headers: authHeader(),
                        responseType: "blob",
                    }
                );

                const blob = new Blob([res.data], { type: "application/pdf" });
                const url = URL.createObjectURL(blob);

                prevUrl = url;
                if (!revoked) setBlobUrl(url);
            } catch (e) {
                console.error(e);
                setError(e?.message || "โหลด PDF ไม่สำเร็จ");
            }
        })();

        return () => {
            revoked = true;
            if (prevUrl) URL.revokeObjectURL(prevUrl);
        };
    }, [id]);

    // Container Styles: แยกตามโหมดการใช้งาน
    const containerStyle = embedded
        ? { width: "100%", height: "100%", minHeight: "600px" } // สำหรับใส่ใน Card (กำหนด minHeight กันไม่ให้มันแบน)
        : { position: "fixed", inset: 0, background: "#111", zIndex: 9999 }; // สำหรับหน้า Full Screen

    if (!id) return <div style={{ padding: 12 }}>ไม่พบ LeaveRequestID</div>;
    if (error) return <div style={{ padding: 12, color: "red" }}>{error}</div>;
    if (!blobUrl) return <div style={{ padding: 12 }}>กำลังโหลด...</div>;

    return (
        <div style={containerStyle}>
            <iframe
                title="LeaveForm PDF"
                src={blobUrl}
                style={{ width: "100%", height: "100%", border: 0 }}
            />
        </div>
    );
};

export default PdfFile;